// Module
var code = `<div class="svc-question__adorner" data-bind="css: rootCss(), attr: { 'data-sv-drop-target-survey-element': element.name || null }, event: { dblclick: (d, e) => dblclick(e), mouseover: function(m, e) { hover(e, \$element); }, mouseleave: function(m, e) { hover(e, \$element); } }">
  <!-- ko if: \$data.showHiddenTitle -->
  <div data-bind="css: \$data.cssCollapsedHiddenHeader">
    <!-- ko if: !!\$data.element.hasTitle -->
      <!-- ko component: { name: 'survey-element-title', params: { element: \$data.element } } --><!-- /ko -->
      <!-- /ko -->
      <!-- ko ifnot: !!\$data.element.hasTitle -->
      <div data-bind="css: \$data.cssCollapsedHiddenTitle">
        <span class="svc-fake-title" data-bind="text: element.name"></span>
      </div>
    <!-- /ko -->
  </div>
  <!-- /ko -->
  <div data-bind="click: \$data.element.isInteractiveDesignElement ? koSelect : null, key2click: { disableTabStop: true }, clickBubble: false, css: css()">
    <div class="svc-question__drop-indicator svc-question__drop-indicator--left"></div>
    <div class="svc-question__drop-indicator svc-question__drop-indicator--right"></div>
    <div class="svc-question__drop-indicator svc-question__drop-indicator--top"></div>
    <div class="svc-question__drop-indicator svc-question__drop-indicator--bottom"></div>
    <!-- ko if: allowDragging && \$data.element.isInteractiveDesignElement -->
    <div class="svc-question__drag-area" data-bind="event: { pointerdown: (model, event)=>{ onPointerDown(event) } }">
      <!-- ko component: { name: 'sv-svg-icon', params: { css: 'svc-question__drag-element', iconName: 'icon-drag-area-indicator_24x16', size: 'auto' } } -->
      <!-- /ko -->
      <div class="svc-question__top-actions">
        <!-- ko component: { name: 'sv-action-bar', params: { model: topActionContainer, handleClick: false } } -->
        <!-- /ko -->
      </div>
    </div>
    <!-- /ko -->
    <!-- ko if: \$data.needToRenderContent -->
    <!-- ko component: { name: 'sv-template-renderer', params: { componentData: null, templateData: templateData } } -->
    <!-- /ko -->
    <!-- ko if: koIsEmptyElement() -->
    <div class="svc-panel__placeholder_frame-wrapper">
      <div class="svc-panel__placeholder_frame">
        <div class="svc-panel__placeholder" data-bind="text: placeholderText"></div>
        <!-- ko if: showAddQuestionButton -->
        <div class="svc-panel__add-new-question svc-action-button" data-bind="click: addNewQuestion, key2click, clickBubble: false">
          <!-- ko component: { name: 'sv-svg-icon', params: { css: 'svc-panel__add-new-question-icon', iconName: 'icon-add_24x24', size: 'auto' } } -->
          <!-- /ko -->
          <span class="svc-add-new-item-button__text" data-bind="text: \$data.addNewQuestionText">
          </span>
        </div>
        <!-- /ko -->
      </div>
    </div>
    <!-- /ko -->

    <!-- ko if: adornerComponent && \$data.element.isInteractiveDesignElement -->
    <!-- ko component: { name: adornerComponent, params: { model: \$data } } -->
    <!-- /ko -->
    <!-- /ko -->

    <!-- ko if: !koIsEmptyElement() && showAddQuestionButton -->
    <div class="svc-panel__add-new-question-container">
      <div class="svc-panel__question-type-selector-popup"><sv-popup params="model: questionTypeSelectorModel.popupModel"></sv-popup></div>
      <div class="svc-panel__add-new-question-wrapper">
        <!-- ko component: { name: 'svc-add-new-question-btn', params: { item: { data: \$data }, buttonClass: 'svc-action-button', renderPopup: false } } -->
        <!-- /ko -->
      </div>
    </div>
    <!-- /ko -->
    <!-- ko if: \$data.element.isInteractiveDesignElement -->
    <div class="svc-question__content-actions" data-bind="event: {focusin: koSelect}">
      <!-- ko component: { name: 'sv-action-bar', params: { model: actionContainer, handleClick: false } } -->
      <!-- /ko -->
    </div>
    <!-- /ko -->
    <!-- /ko -->
  </div>
</div>`;
// Exports
export default code;